/**
 * Shared timing for the home hero: the giant wordmark holds still while the
 * portraits scroll under it, then shrinks into the header logo. Both the
 * header and the hero read the same progress so they stay in step.
 */

/** Scroll position where the shrink starts, as a share of the viewport height. */
export const DOCK_START = 0.38

/** Scroll position where the wordmark has fully become the logo. */
export const DOCK_END = 0.9

export const dockProgress = (scrollY: number, viewportHeight: number): number => {
    const start = viewportHeight * DOCK_START
    const end = viewportHeight * DOCK_END
    const raw = Math.min(1, Math.max(0, (scrollY - start) / (end - start)))

    return raw * raw * (3 - 2 * raw)
}
